module.exports = __webpack_public_path__ + "media/images/flags/bm-7c4660d2a659157589a770f295e603c9.svg";